import { CopyButton } from "./copy-button";

/** A titled block of code with a copy button. Used for install commands and
 *  every wiring snippet. */
export function CodePanel({
  title,
  code,
  language = "",
}: {
  title?: string;
  code: string;
  language?: string;
}) {
  return (
    <div className="overflow-hidden rounded-lg border border-ink-700 bg-ink-800">
      {title && (
        <div className="flex items-center justify-between gap-3 border-b border-ink-700 px-3 py-2">
          <span className="truncate font-mono text-xs text-ink-400">{title}</span>
          <CopyButton value={code} />
        </div>
      )}
      <div className="relative">
        {!title && (
          <div className="absolute right-2 top-2">
            <CopyButton value={code} />
          </div>
        )}
        <pre className="overflow-x-auto px-4 py-3.5 text-[0.8125rem] leading-relaxed text-ink-200">
          <code>{code}</code>
        </pre>
      </div>
      {language && <span className="sr-only">{language}</span>}
    </div>
  );
}
